import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: ProductContextModel;
    extendedStyles?: RsswProductModelStyles;
}

type Props = OwnProps;

export interface RsswProductModelStyles {
    modelName?: TypographyProps;
}

export const rsswProductModel: TypographyProps = {
    mergeCss: true,
    color: COLORS.secondary.base,
    transform: "uppercase",
    size: 16,
    weight: TYPOGRAPHY.weight.black,
    css: css`
        margin-bottom: 8px;
    `,
};

export const rsswProductModelStyles: RsswProductModelStyles = {
    modelName: { ...rsswProductModel },
};

const RsswProductModel: FC<Props> = ({ product, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(rsswProductModelStyles, extendedStyles));

    if (!product.product || product.product?.detail?.modelNumber === "") {
        return null;
    }

    return <Typography {...styles.modelName}>{product.product?.detail?.modelNumber}</Typography>;
};

export default RsswProductModel;
